export const unique = a => [...new Set(a)];

export default {
  unique,
};
